import SerialLabelsTable from './serialLabelsTable'

export default SerialLabelsTable
